import React from 'react';
import {
  FormControl,
  InputLabel,
  TextField,
  Grid,
  GridProps,
  FormHelperText,
} from '@mui/material';
import { FORM_STYLES } from '../../../constants';

interface FormikFieldProps {
  name: string;
  label: string;
  value: string | number;
  onChange: (event: any) => void;
  onBlur: (event: any) => void;
  error?: string;
  placeholder?: string;
  type?: 'text' | 'number' | 'email' | 'tel';
  disabled?: boolean;
  required?: boolean;
  multiline?: boolean;
  rows?: number;
  maxLength?: number;
  gridProps?: GridProps;
}

const FormikField: React.FC<FormikFieldProps> = ({
  name,
  label,
  value,
  onChange,
  onBlur,
  error,
  placeholder,
  type = 'text',
  disabled = false,
  required = false,
  multiline = false,
  rows,
  maxLength,
  gridProps = { xs: 12, md: 4 },
}) => {
  return (
    <Grid item {...gridProps}>
      <FormControl fullWidth size={FORM_STYLES.FIELD_SIZE} error={!!error}>
        <InputLabel 
          shrink 
          style={FORM_STYLES.LABEL}
          htmlFor={name}
        >
          {label} {required && <sup>*</sup>}
        </InputLabel>
        <TextField
          id={name}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          type={type}
          title={(value?.toString()?.length ?? 0) > 30 ? value?.toString() : undefined}
          disabled={disabled}
          multiline={multiline}
          rows={rows}
          variant="outlined"
          error={!!error}
          autoComplete="off"
          inputProps={{
            maxLength,
            style: FORM_STYLES.INPUT,
          }}
        />
        {error && <FormHelperText>{error}</FormHelperText>}
      </FormControl>
    </Grid>
  );
};

export default FormikField;